<template>
  <div class="summaryDetail">
    <el-form ref="form">
      <el-row class="tit">
        <el-col :span="24">{{staffName}}的提成结算</el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="19">
          <el-table
            v-if="tableData.length > 0"
            :data="tableData"
            border
            :cell-style="{height:'42px'}"
            style="width: 100%"
            :header-cell-style="{background:'#EFF1F5',height:'47px'}"
          >
            <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
            <el-table-column align="center" prop="feeName" show-overflow-tooltip label="提成名称">
              <template slot-scope="scope">{{scope.row.feeName | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="isTeam" label="提成类型" width="80">
              <template slot-scope="scope">{{scope.row.isTeam == 1 ?'团队提成':'个人提成'}}</template>
            </el-table-column>
            <el-table-column align="center" prop="sourceList" label="提成范围" width="210">
              <template slot-scope="scope">{{sourceType(scope.row.sourceList) | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="totalAmount" label="月度业绩金额"></el-table-column>
            <el-table-column align="center" prop="detailList" label="提成系数" width="220">
              <template slot-scope="scope">
                <template v-if="scope.row.detailList && scope.row.detailList.length > 0">
                  <div class="sale" v-for="(i,index) in scope.row.detailList" :key="index">
                    <label>{{i.bottom}}{{(index == scope.row.detailList.length-1)?'+':'-'}}{{i.top==10000000?'':i.top}}：</label>
                    <span class="redFont">{{scope.row.feeType == 1?'':'￥'}}{{i.feeFactor}}{{scope.row.feeType == 1?'%':''}}</span>
                  </div>
                </template>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="currentFee" label="各提成"></el-table-column>
          </el-table>
          <span v-else>无</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">
          <div class="seize"></div>
        </el-col>
        <el-col :span="23">
          <div class="btnOptions">
            <el-button class="darkBtn" @click="closeTab">关闭</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script type="text/javascript">
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      staffName:'',
      tableData:'',
    };
  },
  created() {
    this.detailInfo();
  },
  computed: {
    sourceType(){
      return function(val){
        let data = [];
        if(val){
          for(let i of val){
            if(i.sourceId && data.indexOf(i.sourceId) == -1){
              data.push(vFilter.filterScorce(i.sourceId));
            }
          }
        }
        return data.length ? data.join('、'):'无';
      }
    }
  },
  methods: {
    detailInfo() {
      this.staffName = this.$store.state.royaltyData.staffName;
      this.tableData = this.$store.state.royaltyData.storeFeeDTOS
    },
    closeTab() {
      // 关闭当前tab
      if(this.$store.state.royaltyData.type == 1){
        this.$router.push("/financeManageCenter/royaltyPersonSum");
      }else{
        this.$router.push("/financeManageCenter/royaltyTeamSum");
      }
    },
  }
};
</script>
<style lang="less" scoped>
.summaryDetail {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
  padding: 80px 0 60px;
  position: relative;
  .el-row.tit {
    color: #444;
    margin-bottom: 30px;
  }
  .el-row {
    margin-bottom: 15px;
  }
  .seize {
    height: 20px;
  }
}
</style>
<style lang="less">
.summaryDetail {
  .el-table td,
  .el-table th {
    padding: 0;
  }
  .btnOptions {
    text-align: center;
    margin: 0;
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/summaryDetail.vue